import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class choferService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}logistica/chofer`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/chofer/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/chofer/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/chofer/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/chofer/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/chofer`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/chofer`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}logistica/chofer/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}logistica/chofer/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new choferService();